<template>
  <div class="gc-screen-pdf-view">
    <DxDropDownButton
      :items="getItems"
      :keyExpr="'ScreenLayoutApplicationFeatureCode'"
      :displayExpr="'ReportDisplayName'"
      :drop-down-options="{ width: 200 }"
      class="gc-dropdown-icon-button"
      icon="pdffile"
      styling-mode="text"
      :show-arrow-icon="false"
      :onItemClick="onItemClick"
      v-if="getItems.length > 1"
    />
    <DxButton class="pdf-view-btn" icon="pdffile" v-else />
  </div>
</template>

<script>
import ReportService from "../../_services/api/templates/report.service";

export default {
  props: {
    buttonColor: {
      type: String,
      default: "#fff",
    },
    screenName: {
      type: String,
      default: undefined,
    },
    onPreviewPDF: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      pdfItems: [],
      validationSummaryVisible: false,
      validationItems: [],
    };
  },
  created() {
    // Any initialization logic can go here
    setTimeout(() => {
      if (document.getElementsByClassName("pdf-view-btn")[0]) {
        document.getElementsByClassName(
          "pdf-view-btn"
        )[0].style.backgroundColor = this.buttonColor;
      }
    }, 100);

    if (this.screenName) {
      this.getPdfViews();
    }
  },
  methods: {
    async getPdfViews() {
      try {
        const response = await ReportService.getReportPreviewScreenName(
          this.screenName
        );

        if (response && response.data) {
          this.pdfItems = response.data.value;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching PDF views:", error);
      }
    },
    onItemClick(e) {
      // Handle item click
      this.onPreviewPDF(e.itemData);
    },
  },
  computed: {
    getItems() {
      return this.pdfItems;
    },
  },
};
</script>

<style lang="scss">
.gc-screen-pdf-view {
}
</style>
